class TileHolder {

    constructor(x, y, s, l, tile) {
        
        this.x = x;
        this.y = y;
        this.s = s;
        this.l = l;
        this.tile = tile;
        this.d = 0;
    }

    isSameSuit() {
        return this.tile.a === this.tile.b;
    }

    isVertical() {

        while (this.d >= 360) {
            this.d -= 360;
        }

        return this.d === 0 || this.d === 180;
    }
    
    getDimensions() {

        const h = this.isVertical() ? this.s : this.l;
        const v = this.isVertical() ? this.l : this.s;

        return {
            h: h,
            v: v
        };
    }

    getAnchorPoint(dir) {
        return this.getOffsetPoint(this.x, this.y, dir);
    }

    getOffsetPoint(x, y, dir) {

        const dim = this.getDimensions();

        return { 
            'x': x + (dir.fx * dim.h / 2),
            'y' : y + (dir.fy * dim.v / 2)
        };
    }
}

export default TileHolder;


// WEBPACK FOOTER //
// ./src/TileHolder.jsx